<template>
    <el-upload
      class="my_upload"
      :action="action"
      :headers="headers"
      :before-upload="handleBeforeUpload"
      :on-success="handleSuccess"
      :on-error="handleError"
      :show-file-list="false"
      accept=".xls">
      <el-button :loading="loading" type="primary" :icon='icon' :size='size'>{{name}}</el-button>
    </el-upload>
</template>

<script>
import projectConfig from '@/core/config';
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'small'
    }
  },
  data () {
    return {
      projectConfig,
      action: '',
      headers:{},
      token: localStorage.getItem('token'),
      loading:false
    }
  },
  created() {
    this.action = this.projectConfig.baseUrl + "admin/upms/oaStaffLicense/import"
    this.headers = {
      'Authorization' : this.token
    }
  },
  methods: {
    handleBeforeUpload () {
      this.loading = true
    },
    handleSuccess(){
      this.loading = false
      this.$message({
        message: '上传成功',
        type: 'success'
      });
      this.$emit('submitForm', false)
    },
    handleError(){
      this.loading = false
      this.$message.error('上传失败');
    }
  }
}
</script>
<style lang="scss">
.my_upload{
  display: inline-block;
  margin-left: 10px;
}
</style>